import React from "react";
import ImageDisplayOption from "./imageDisplayOption/ImageDisplayOption";
import UrlRow from "./imageDisplayOption/urlRow/UrlRow";
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import classes from "./ImageDisplayOptions.module.css";
import { useSelector } from "react-redux";

const ImageDisplayOptions = ({ isImageButton, onIsImageButtonChange, imageLink, onImageLinkChange }) => {

    const { texts } = useSelector((state) => state.translate);

    return (
        <div className={classes.DisplayOptions}>
            <ImageDisplayOption
                name="imageMode"
                checked={!isImageButton}
                onChange={() => onIsImageButtonChange(false)}
                title={texts.imageOnly}
                desc={texts.imageOnlyDesc}
                icon={iconsList.galleryAdd}
            />

            <ImageDisplayOption
                name="imageMode"
                checked={isImageButton}
                onChange={() => onIsImageButtonChange(true)}
                title={texts.imageAsButton}
                desc={texts.imageAsButtonDesc}
                icon={iconsList.edit}
            >
                {isImageButton && (
                    <UrlRow
                        imageLink={imageLink}
                        onImageLinkChange={onImageLinkChange}
                        label={texts.imageButtonUrl}
                        placeholder="https://www.school-example.com"
                    />
                )}
            </ImageDisplayOption>
        </div>
    );
};

export default ImageDisplayOptions;
